requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCookieBanner', (delay) => ({
      show: false,
      prefs: false,
      choice: { analytics: false, marketing: false, preferences: false },
      init() {
        setTimeout(() => {
          window.Shopify.loadFeatures([
            {
              name: 'consent-tracking-api',
              version: '0.1',
            }
          ],
          (error) => {
            if (error) {
              throw error;
            }

            const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
            const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
            // The close cross hides the banner for this session without recording a choice.
            let closedThisSession = false;
            try { closedThisSession = sessionStorage.getItem('rm_consent_closed') === '1'; } catch (e) {}

            if(!userCanBeTracked && userTrackingConsent === 'no_interaction' && !closedThisSession) {
              requestAnimationFrame(() => {
                this.show = true;
              });
            }

            document.dispatchEvent(new CustomEvent("eurus:customer-privacy:loaded"));
          });
        }, delay * 1000);
      },
      setConsent(consent) {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {});
          requestAnimationFrame(() => {
            this.show = false;
          });
        }
      },
      handleAccept() {
        this.setConsent({ analytics: true, marketing: true, preferences: true });
      },
      handleDecline() {
        this.setConsent({ analytics: false, marketing: false, preferences: false });
      },
      handleSave() {
        this.setConsent({
          analytics: this.choice.analytics,
          marketing: this.choice.marketing,
          preferences: this.choice.preferences
        });
      },
      handleClose() {
        try { sessionStorage.setItem('rm_consent_closed', '1'); } catch (e) {}
        this.show = false;
      }
    }));
  });
});
